import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import ConfigureOptions from '../ConfigureOptions'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { templateStyles } from './templateStyles'

export const SELECT_DEFAULT_OPTION_TEXT = 'Select'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const { props } = input

  const options = props.preserveOrder
    ? props.options || []
    : (props.options || []).slice().sort((a: any, b: any) => a.key.localeCompare(b.key))
  return (
    <div>
      <InputLabel
        title={props.label}
        required={props.required && isEmpty(props.value)}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.requiredLabelIconName}
      >
        <div className="bp5-select bp5-fill">
          <select onChange={e => onFormPreviewChange(index, e.target.value)} value={props.value} disabled={false}>
            <option>{SELECT_DEFAULT_OPTION_TEXT}</option>
            {options.map((opt: any, i: number) => {
              return (
                <option key={i} /* eslint-disable-line */ value={opt.value}>
                  {opt.value}
                </option>
              )
            })}
          </select>
        </div>
      </InputLabel>
      {props.helpText && (
        <Help>
          <div>{props.helpText}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  return (
    <div>
      <ConfigureOptions input={input} onChange={onChange} />
    </div>
  )
}
